module.exports = __webpack_public_path__ + "img/kf.2196bd0a.png";